<mat-dialog-content>
  <mat-selection-list flexLayout="column" flexLayoutGap="10px" #selectionList [multiple]="multiple">
    @if (items) {
      <ng-container>
        @for (item of items; track item.deviceName) {
          <mat-list-option
            [value]="item"
            (selectedChange)="onOptionSelected(item)"
            [selected]="isSelected(item)"
          >
            <div flexLayout="row">
              @for (column of columns; track column.key) {
                <div [flex]="column?.width?.toString()">
                  <div>
                    <span>{{ item[$any(column.key)] }}</span>
                  </div>
                </div>
              }
            </div>
          </mat-list-option>
        }
        @if (items.length === 0) {
          <mat-list-item>{{ noRecords }}</mat-list-item>
        }
      </ng-container>
    }
  </mat-selection-list>

  @if (title === "Volume") {
    <div
      flexLayout="row"
      flexLayoutGap="16px"
      flexLayoutAlign="space-between center"
      class="volume"
    >
      <mat-label>{{ title + " %" }}</mat-label>
      <input
        class="volume-input"
        mat-input
        type="number"
        min="0"
        max="100"
        [(ngModel)]="volume"
        #volumeModel="ngModel"
        (ngModelChange)="checkMax(volumeModel)"
        (keydown)="preventNegative($event)"
      />
    </div>
    @if (volumeModel.errors?.maxExceeded) {
      <mat-error flexLayout="row" flexLayoutAlign="end end" class="volume"
        >Volume cannot exceed 100</mat-error
      >
    }
  } @else if (title === "Mute") {
    <mat-slide-toggle
      [checked]="selectedItem && isMuted(selectedItem)"
      (change)="onToggle($event.checked ? 'Yes' : 'No')"
      class="toggle"
      labelPosition="before"
      flexLayout="column"
      flexLayoutGap="10px"
      >{{ title }}</mat-slide-toggle
    >
  }
</mat-dialog-content>
<mat-dialog-actions flexLayoutAlign="end">
  <button mat-flat-button mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="selectionList.selectedOptions.isEmpty() || (disabled$ | async)"
    type="button"
  >
    {{ button }}
  </button>
</mat-dialog-actions>
